import { format, formatDistance, isWithinInterval } from "date-fns"

export const formatTimestamp = (date: Date): string => {
  const oneWeekAgo = new Date()
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7)

  let formattedDate
  if (isWithinInterval(date, { start: oneWeekAgo, end: new Date() })) {
    formattedDate = formatDistance(date, new Date(), { addSuffix: true })
  } else {
    formattedDate = format(date, 'MMM d, yyyy')
  }

  return formattedDate
}

export function sendMessage(eventType: string, data?: object) {
  const message = Object.assign({}, data, {event_type: eventType})
  window.parent.postMessage(message, '*')
}

export function requestWebId(): Promise<string | null> {
  return new Promise((resolve) => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.event_type === 'web_id_response') {
        window.removeEventListener('message', handleMessage)
        resolve(event.data.webId || null)
      }
    }
    
    window.addEventListener('message', handleMessage)
    sendMessage('request_web_id')
  })
}

export const getMediaType = (mimeType: string) => {
  if (mimeType.startsWith('audio/')) return 'audio'
  if (mimeType.startsWith('video/')) return 'video'
  if (mimeType === 'application/pdf') return 'pdf'
  if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return 'doc'
  if (mimeType.startsWith('image/')) return 'image'
  return 'unknown'
}

export const lazyWithRetry = (lazyComponent: () => Promise<{ default: any }>, retries = 3) => {
  return new Promise<{ default: any }>((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retries === 0) {
            reject(error)
            return
          }
          lazyWithRetry(lazyComponent, retries - 1).then(resolve, reject)
        }, 1500)
      })
  })
}